(ns frontend.view.settings2.web-form.thank-you-page
  (:require [clojure.string :as string]
            [common.localization :as loc]
            [common.url :as url]
            [frontend.logging :as logging]
            [frontend.view.settings2.web-form.events :as events]
            [reagent.core :as r]
            [ui.components.button.view :as button]
            [ui.editors.labelled-input.view :as labelled-input]))

(defn heading-input
  [{:keys [webentry entity-atom]}]
  (let [attribute :webentry/thank-you-title
        old-value (get webentry attribute)]
    [:div
     [labelled-input/view
      {:label (loc/tr :webentry-thank-you-heading)
       :data-type :data.type/text-simple
       :value     old-value
       :on-change (fn [new-value]
                    (swap! entity-atom assoc attribute new-value))
       :on-blur  (fn [new-value]
                   (events/save-webform!
                    webentry
                    attribute
                    new-value
                    (fn [_]
                      (logging/info "Update successful!"))
                    (fn [err]
                      (logging/error "Failed to update " err))))}]]))

(defn message-input
  [{:keys [webentry entity-atom]}]
  (let [attribute :webentry/thank-you-text
        old-value (get webentry attribute)]
    [:div
     [labelled-input/view
      {:label (loc/tr :webentry-thank-you-message)
       :data-type :data.type/text-multiline
       :value     old-value
       :on-change (fn [new-value]
                    (swap! entity-atom assoc attribute new-value))
       :on-blur  (fn [new-value]
                   (events/save-webform!
                    webentry
                    attribute
                    new-value
                    (fn [_]
                      (logging/info "Update successful!"))
                    (fn [err]
                      (logging/error "Failed to update " err))))}]]))

(defn direct-to-input
  [{:keys [webentry entity-atom]}]
  (let [attribute :webentry/redirect-to
        old-value (get webentry attribute)]
    [:div
     [labelled-input/view
      {:label (loc/tr :web-form-settings/direct-visitors)
       :data-type :data.type/text-url
       :value     (if (string/starts-with? "https://" old-value)
                    old-value
                    (url/prepend-protocol (str old-value) :https))
       :on-change (fn [new-value]
                    (swap! entity-atom assoc attribute new-value))
       :on-blur  (fn [new-value]
                   (events/save-webform!
                    webentry
                    attribute
                    new-value
                    (fn [_]
                      (logging/info "Update successful!"))
                    (fn [err]
                      (logging/error "Failed to update " err))))}]
     [:span {:class "text-xs"} (loc/tr :web-form-settings/direct-visitors-message)]]))

(defn webentry-url
  [webentry]
  (let [{:keys [webentry/apikey]} webentry
        origin (str (.-origin js/document.location) "/")
        webentry-address-start (str origin "webentry-thank-you/")
        url (str webentry-address-start apikey)]
    url))

(defn view
  [{:keys [state webentry entity-atom]}]
  (let [state-atom (r/atom {})]
    (fn [{:keys [state webentry entity-atom]}]
      [:div
       {:class "flex flex-col gap-3"}
       [:div
        {:class "font-semibold text-xl"}
        (loc/tr :web-form-settings/title-thank-you-page)]
       [:div
        {:class "flex flex-col gap-3"}
        [:div
         [heading-input
          {:webentry    webentry
           :entity-atom entity-atom
           :state-atom  state-atom}]]

        [:div
         [message-input
          {:webentry    webentry
           :entity-atom entity-atom
           :state-atom  state-atom}]]

        [:div
         [direct-to-input
          {:webentry    webentry
           :entity-atom entity-atom
           :state-atom  state-atom}]]
        [:div
         {:class "flex justify-start"}
         [button/secondary-open
          {:class "px-0 flex gap-2 items-center"
           :on-click (fn [_]
                       (.open js/window
                              (webentry-url webentry)
                              "_blank"))}
          [:i.fas.fa-external-link-alt]
          (loc/tr :web-form-settings/preview-thank-you-page)]]]])))
